import type {Category} from "~/types/event";

export const useCategory = () => {
  const baseUrl = '/categories'
  const {fetch} = useAjax()

  const findAllCategories = async (): Promise<Category[]> => {
    try {
      return await fetch<Category[]>(baseUrl, {
        method: 'GET'
      })
    } catch (e) {
      return []
    }
  }

  return {findAllCategories}

}
